webpackJsonp([1],{

/***/ "+hMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "/SIw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik00MDQuNDczNiA2MDEuNmEzOC4yNzIgMzguMjcyIDAgMCAxLTQuOTE1MiAxNC44OTI4TDM3MS4yMDY0IDY2NS42SDc4MC44YTM4LjQgMzguNCAwIDAgMSAwIDc2LjhIMzA3LjJhMzguNCAzOC40IDAgMCAxLTM4LjM1NTItNDAuMzI2NCAzOC4yMjA4IDM4LjIyMDggMCAwIDEgNS4wNzUyLTIxLjU2OGw0Ni42NDMyLTgwLjc4NzItNy4wOTEyLTI2LjQ1NzZhNTEuMjU3NiA1MS4yNTc2IDAgMCAxLTMuNjM1Mi05LjYxMjhsLTY4LjU3Ni0yNTZhNTEuNDQzMiA1MS40NDMyIDAgMCAxLTEuNjUxMi0xMC4wNDhsLTI5LjYxMjgtMTEwLjUwODgtODkuOTcxMi0yNC4xMDg4YTM4LjQgMzguNCAwIDAgMSAxOS44Nzg0LTc0LjE3NmwxMTEuMjcwNCAyOS44MTEyYTM4LjQgMzguNCAwIDAgMSAyNy42NzM2IDI5LjMxMmMwLjQwMzIgMS4wOTQ0IDAuNzYxNiAyLjIxNDQgMS4wNjg4IDMuMzY2NEwzMDQuNTQ0IDI0My4yaDU1Ni43MzZhNTEuMiA1MS4yIDAgMCAxIDQ5LjQ1OTIgNjQuNDQ4bC02OC41NzYgMjU2YTUxLjIgNTEuMiAwIDAgMS00OS40NTI4IDM3Ljk1Mkg0MDQuNDczNnpNMzQ1LjYgOTI4Yy00Mi40MTI4IDAtNzYuOC0zNC4zODcyLTc2LjgtNzYuOHMzNC4zODcyLTc2LjggNzYuOC03Ni44IDc2LjggMzQuMzg3MiA3Ni44IDc2LjgtMzQuMzg3MiA3Ni44LTc2LjggNzYuOHogbTQxNiAwYy00Mi40MTI4IDAtNzYuOC0zNC4zODcyLTc2LjgtNzYuOHMzNC4zODcyLTc2LjggNzYuOC03Ni44IDc2LjggMzQuMzg3MiA3Ni44IDc2LjgtMzQuMzg3MiA3Ni44LTc2LjggNzYuOHoiICAvPjwvc3ZnPgo="

/***/ }),

/***/ "/YhV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTg2OTQ3MjU2MDYxIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjIxNjEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBmaWxsPSIjNjY2IiBkPSJNNTEyIDBDMjI5LjIwNTMzMyAwIDAgMjI5LjIwNTMzMyAwIDUxMnMyMjkuMjA1MzMzIDUxMiA1MTIgNTEyIDUxMi0yMjkuMjA1MzMzIDUxMi01MTJTNzk0Ljc5NDY2NyAwIDUxMiAweiBtMCA3OTYuNDU4NjY3QTU2LjkxNzMzMyA1Ni45MTczMzMgMCAxIDEgNTExLjk1NzMzMyA2ODIuNjY2NjY3IDU2LjkxNzMzMyA1Ni45MTczMzMgMCAwIDEgNTEyIDc5Ni40NTg2Njd6IG01NC4xODY2NjctMjI3Ljc5NzMzNGgwLjEyOGE2MC41MDEzMzMgNjAuNTAxMzMzIDAgMCAxLTUzLjgwMjY2NyA1NS44OTMzMzRjMi4wNDggMC4yNTYgMy44ODI2NjcgMS4xNTIgNS45NzMzMzMgMS4xNTJoLTExLjgxODY2NmMyLjA0OCAwIDMuODQtMC45ODEzMzMgNS44NDUzMzMtMS4xMDkzMzRhNTkuMDkzMzMzIDU5LjA5MzMzMyAwIDAgMS01My4xNjI2NjctNTUuODkzMzMzbC0xMy4wNTYtMjg0LjE2YTU0LjMxNDY2NyA1NC4zMTQ2NjcgMCAwIDEgNTQuNjEzMzM0LTU3LjA0NTMzM2gyNi4yODI2NjZhNTIuOTkyIDUyLjk5MiAwIDAgMSA1NC4xODY2NjcgNTcuMDAyNjY2bC0xNS4xNDY2NjcgMjg0LjE2eiIgcC1pZD0iMjE2MiI+PC9wYXRoPjwvc3ZnPgo="

/***/ }),

/***/ "/eZ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_config_js__ = __webpack_require__("BK/k");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      msgUrl: __WEBPACK_IMPORTED_MODULE_0__util_config_js__["a" /* default */].msgUrl,
      cl: sessionStorage.cl,
      isGoogleSource: source === sourceData.googleSource,
      cConf: cConf
    };
  },

  methods: {
    /**
     * 订单查询
     */
    search: function search() {
      this.$emit('search');
    },

    /**
     * 客服咨询
     */
    service: function service() {
      if (cConf.serviceLineMe) {
        window.open('https://line.me/ti/p/UnTgQVExys#~');
      } else {
        window.open(this.msgUrl);
      }
      this.$emit('service');
    },

    /**
     * 下单
     */
    pay: function pay() {
      this.$emit('pay');
    }
  }
});

/***/ }),

/***/ "/hfh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_permission__ = __webpack_require__("vZz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_header_vue__ = __webpack_require__("Mitt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_detail_swiper_vue__ = __webpack_require__("YOb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_detail_supply_vue__ = __webpack_require__("vlyD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_detail_brief_vue__ = __webpack_require__("QAmn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_detail_module_title_vue__ = __webpack_require__("YwTY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_detail_product_info_vue__ = __webpack_require__("mw5R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_detail_footer_vue__ = __webpack_require__("624t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vuex_store_js__ = __webpack_require__("YtJ0");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'zf-header': __WEBPACK_IMPORTED_MODULE_5__components_common_header_vue__["a" /* default */],
    "zf-swiper": __WEBPACK_IMPORTED_MODULE_6__components_detail_swiper_vue__["a" /* default */],
    'zf-supply': __WEBPACK_IMPORTED_MODULE_7__components_detail_supply_vue__["a" /* default */],
    'zf-brief': __WEBPACK_IMPORTED_MODULE_8__components_detail_brief_vue__["a" /* default */],
    'zf-footer': __WEBPACK_IMPORTED_MODULE_11__components_detail_footer_vue__["a" /* default */],
    'zf-title': __WEBPACK_IMPORTED_MODULE_9__components_detail_module_title_vue__["a" /* default */],
    'zf-info': __WEBPACK_IMPORTED_MODULE_10__components_detail_product_info_vue__["a" /* default */]
  },
  data: function data() {
    return {
      // 商品详情
      detailData: {
        images: [],
        content: {
          content_iv: []
        },
        price: '',
        compare_price: ''
      },
      // 配置
      configData: {
        page_detail: {
          detail: {
            show_buy_button: false,
            show_comment: false,
            show_deadline: false,
            show_feature: false,
            show_service: false
          },
          foot: {
            btn_contact: false,
            btn_search_order: false
          },
          top: {
            show: false,
            show_share: false
          }
        }
      },
      // 语言模板
      lang: {},
      // 'success':成功  'error': 失败
      loaded: null,
      isGoogleSource: source === sourceData.googleSource,
      isPromotion: false
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_12__vuex_store_js__["a" /* default */].commit('SET_HARDLOADING', true);
    this.getLang();
    this.getDetail();
    this.getConfig();

    var homeConfig = ["qualitygogo.com", "golifestoretw.com", "17ihome.com", "soanclothes.com", "americanwsh.com", "warmthcorner.com", "bluebirderr.com", "stylels.com", "darkgogo.com", "twgolifestore.com", "stylishhoing.com", "wshnetwork.com", "pomeloinn.com", "allbuythailand.com"];
    var host = location.host;
    var reg = /.*?([a-z0-9--]{1,200}.com)$/;
    var regRes = host.match(reg);
    if (regRes) {
      var rootHost = regRes[1];
      if (homeConfig.indexOf(rootHost) > -1) {
        this.isPromotion = true;
      }
    }
  },

  methods: {
    /**
     * 获取语言模板
     */
    getLang: function getLang() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var lang;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(sessionStorage.getItem("lang") && JSON.parse(sessionStorage.getItem("lang")).cl === sessionStorage.cl)) {
                  _context.next = 4;
                  break;
                }

                _this.lang = JSON.parse(sessionStorage.getItem("lang"));
                _context.next = 9;
                break;

              case 4:
                _context.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["a" /* langInfo */])();

              case 6:
                lang = _context.sent;

                _this.lang = lang.data.data;
                sessionStorage.lang = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ cl: sessionStorage.cl }, lang.data.data));

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    /**
     * 获取配置信息
     */
    getConfig: function getConfig() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var configData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(sessionStorage.getItem("configData") && JSON.parse(sessionStorage.getItem("configData")).cl === sessionStorage.cl)) {
                  _context2.next = 4;
                  break;
                }

                _this2.configData = JSON.parse(sessionStorage.getItem("configData"));
                _context2.next = 8;
                break;

              case 4:
                _context2.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["b" /* getConfig */])();

              case 6:
                configData = _context2.sent;

                if (configData.data && configData.data.data) {
                  _this2.configData = configData.data.data;
                  sessionStorage.configData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ cl: sessionStorage.cl }, configData.data.data));
                }

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    /**
     * 获取详情
     */
    getDetail: function getDetail() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var params, s_time;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  item: _this3.$route.query.id || '',
                  path: _this3.$route.query.path || ''
                };
                s_time = Date.now();

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["n" /* shopDetail */])(params).then(function (res) {
                  __WEBPACK_IMPORTED_MODULE_12__vuex_store_js__["a" /* default */].commit('SET_HARDLOADING', false);
                  if (res.data && res.data.data) {
                    _this3.loaded = 'success';
                    _this3.detailData = res.data.data;
                    // 价格存入cookie当中
                    _this3.setCookie("price", _this3.detailData.price);
                  } else {
                    _this3.loaded = 'error';
                    console.log('网络错误或没有相关商品');
                    var err = {
                      url: res.config.url,
                      params: params,
                      request_time: Date.now() - s_time,
                      status: res.status || res.response && res.response.status || -1,
                      message: res.message
                    };
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["r" /* errorCatch */])(err);
                  }
                  gtag('set', 'currencyCode', _this3.detailData.iso_code);
                  fbq('track', 'ViewContent', {
                    content_ids: [_this3.detailData.product_hash],
                    content_type: 'product',
                    value: _this3.detailData.price,
                    currency: _this3.detailData.iso_code
                  });
                  ttq.track('ViewContent', {
                    content_ids: [_this3.detailData.product_hash],
                    content_type: 'product',
                    value: _this3.detailData.price,
                    currency: _this3.detailData.iso_code
                  });
                  var loadTime = Date.now() - startTime;
                  gtag('event', 'ViewContent', {
                    event_category: window.location.href,
                    event_label: 'home',
                    value: loadTime
                  });
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["c" /* mallSubmit */])({
                    // hash: this.detailData.product_hash,
                    event_name: 'ViewContent',
                    event_label: 'home',
                    value: loadTime
                  });

                  // 发送cartsee埋点数据
                  var count = 0;
                  var uuid = _this3.generateUUID();
                  _this3.cartseePost(count, uuid);
                }).catch(function (e) {
                  __WEBPACK_IMPORTED_MODULE_12__vuex_store_js__["a" /* default */].commit('SET_HARDLOADING', false);
                });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    /**
     * 跳转页面顶部
     */
    toTop: function toTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },

    /**
     * 跳转付款页面
     */
    goPay: function goPay(btnName) {
      if (this.loaded === 'error') {
        this.getDetail();
      } else if (localStorage.source === sourceData.yahooSource) {
        location.pathname = '/pay';
      } else {
        __WEBPACK_IMPORTED_MODULE_12__vuex_store_js__["a" /* default */].commit('SET_HARDLOADING', true);
        this.$router.push({
          path: '/pay',
          query: {
            id: this.$route.query.id,
            path: this.$route.query.path
          }
        });
      }
      fbq('track', 'AddToCart', {
        content_ids: [this.detailData.product_hash],
        content_type: 'product',
        value: this.detailData.price,
        currency: this.detailData.iso_code
      });
      ttq.track('AddToCart', {
        content_ids: [this.detailData.product_hash],
        content_type: 'product',
        value: this.detailData.price,
        currency: this.detailData.iso_code
      });
      gtag('event', 'AddToCart', {
        event_category: window.location.href,
        event_label: btnName,
        value: this.detailData.price
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["c" /* mallSubmit */])({
        // hash: this.detailData.product_hash,
        event_name: 'AddToCart',
        event_label: btnName,
        value: this.detailData.price,
        event_currency: this.detailData.iso_code
      });
    },

    /**
     * 分享
     */
    share: function share() {
      console.log('分享');
    },

    /**
     * 订单查询
     */
    search: function search() {
      this.$router.push({
        path: '/search',
        query: {
          id: this.$route.query.id,
          path: this.$route.query.path
        }
      });
      gtag('event', 'OrderTracking', {
        event_category: window.location.href,
        event_label: 'query',
        value: this.detailData.price
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["c" /* mallSubmit */])({
        // hash: this.detailData.product_hash,
        event_name: 'OrderTracking',
        event_label: 'query'
      });
    },

    /**
     * 客服
     */
    service: function service() {
      gtag('event', 'CustomerService', {
        event_category: window.location.href,
        event_label: 'home',
        value: this.detailData.price
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["c" /* mallSubmit */])({
        // hash: this.detailData.product_hash,
        event_name: 'CustomerService',
        event_label: 'home'
      });
    },

    /**
     * 触摸轮播图
     */
    swiperTouch: function swiperTouch() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["c" /* mallSubmit */])({
        // hash: this.detailData.product_hash,
        event_name: 'SlideTop',
        event_label: 'home_top'
      });
    },

    /**
     * 详情图片加载
     */
    imgLoad: function imgLoad(event) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_permission__["c" /* mallSubmit */])({
        // hash: this.detailData.product_hash,
        event_name: 'SlideDetail',
        event_label: 'home_detail_' + event.index,
        event_run: event.timeStamp
      });
    },
    cartseePost: function cartseePost(count, uuid) {
      var _this4 = this;

      if (count < 10) {
        // 条件满足时的处理逻辑
        if (window.cartq) {
          count = 10;
          window.cartq('track', 'Site/Visit', {
            "pathName": window.location.href, // 当前页面地址 location.href
            "email": "", // 用户的email,在已登录情形下才会有
            "phone": "" // 用户的phone,在已登录情形下才会有
          }, {
            "uid": uuid, //第三方的唯一用户标识, 类似cookie
            "customerId": "" //用户id，在已登录情形下才会有 ，
          });

          window.cartq('track', 'Site/ViewProduct', {
            pathName: window.location.href, //当前页面地址
            "productId": new URLSearchParams(window.location.search).get('id'), //商品信息
            "productName": sessionStorage.seo_title, //商品信息
            "price": this.getCookie("price"), //商品信息
            "compareAtPrice": "", //商品信息  （选填）
            "email": "", // 用户的email
            "phone": "" // 用户的phone
          }, {
            "uid": uuid, //第三方的唯一用户标识, 类似cookie
            "customerId": "" //用户id，在已登录情形下才会有 ，
          });
        }
        count++;
        setTimeout(function () {
          _this4.cartseePost(count, uuid);
        }, 2000); // 2秒钟后再次执行循环器
      }
    },
    generateUUID: function generateUUID() {
      // 1. 判断cookie是否有唯一uuid：cartsee_uuid
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.startsWith('cartsee_uuid=')) {
          return cookie.substring('cartsee_uuid='.length);
        }
      }

      // 2. 新建uuid存入cookie
      var cartsee_uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
      document.cookie = 'cartsee_uuid=' + cartsee_uuid;
      return cartsee_uuid;
    },

    /**
     * 设置cookie
     * @param c_name
     * @param value
     * @param expireDays
     */
    setCookie: function setCookie(c_name, value) {
      var expireDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var exDate = new Date();
      exDate.setDate(exDate.getDate() + expireDays);
      document.cookie = c_name + "=" + escape(value) + (expireDays == null ? "" : ";expires=" + exDate.toGMTString());
    },

    /**
     * 获取cookie
     * @param cookieName
     * @return {string}
     */
    getCookie: function getCookie(cookieName) {
      var strCookie = document.cookie;
      var arrCookie = strCookie.split("; ");
      for (var i = 0; i < arrCookie.length; i++) {
        var arr = arrCookie[i].split("=");
        if (cookieName === arr[0]) {
          return unescape(arr[1]);
        }
      }
      return "";
    }
  }
});

/***/ }),

/***/ "/pee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__("/hfh");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_942e7d82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__("zmit");
function injectStyle (ssrContext) {
  __webpack_require__("sZlY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-942e7d82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_942e7d82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2U1J":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNGRjk1MDIiIGQ9Ik0yMzguMSA1MjAuNWMtMTcuNiAwLTMxLjktMTQuMy0zMS45LTMxLjkgMC0xNy42IDE0LjMtMzEuOSAzMS45LTMxLjloMjkzYzE3LjYgMCAzMS45IDE0LjMgMzEuOSAzMS45IDAgMTcuNi0xNC4zIDMxLjktMzEuOSAzMS45aC0yOTN6TTIzOC4xIDczMy42Yy0xNy42IDAtMzEuOS0xNC4zLTMxLjktMzEuOXMxNC4zLTMxLjkgMzEuOS0zMS45aDE4Ni41YzE3LjYgMCAzMS45IDE0LjMgMzEuOSAzMS45cy0xNC4zIDMxLjktMzEuOSAzMS45SDIzOC4xek0yNDEuNiAzMTQuOWMtMTcuNiAwLTMxLjktMTQuMy0zMS45LTMxLjlzMTQuMy0zMS45IDMxLjktMzEuOWg0MjYuMWMxNy42IDAgMzEuOSAxNC4zIDMxLjkgMzEuOSAwIDE3LjUtMTQuMyAzMS43LTMxLjggMzEuOUgyNDEuNnoiICAvPjxwYXRoIGZpbGw9IiNGRjk1MDIiIGQ9Ik0xNjAgOTI2LjZjLTQ2LjkgMC04NS4xLTM4LjItODUuMS04NS4xVjE0OS4xYzAtNDYuOSAzOC4yLTg1LjEgODUuMS04NS4xaDU4NmM0Ni45IDAgODUuMSAzOC4yIDg1LjEgODUuMXYyOTcuNGMwIDE3LjYtMTQuMyAzMS45LTMxLjkgMzEuOS0xNy42IDAtMzEuOS0xNC4zLTMxLjktMzEuOVYxNDkuMWMwLTExLjgtOS42LTIxLjQtMjEuNC0yMS40SDE2MGMtMTEuOCAwLTIxLjQgOS42LTIxLjQgMjEuNHY2OTIuNGMwIDExLjggOS42IDIxLjQgMjEuNCAyMS40aDMwNC41YzE3LjUgMCAzMS44IDE0LjIgMzEuOSAzMS44IDAgMTcuNi0xNC4zIDMxLjgtMzEuOSAzMS44SDE2MHoiICAvPjxwYXRoIGZpbGw9IiNGRjk1MDIiIGQ9Ik05MTcuMiA5NTkuOWMtOC41IDAtMTYuNS0zLjMtMjIuNS05LjNsLTc4LjUtNzguNS01LjMtMC41LTAuNiAwLjRjLTMxLjcgMjEuNi02OC43IDMzLTEwNyAzMy0xMDUuMiAwLTE5MC44LTg1LjYtMTkwLjgtMTkwLjhzODUuNi0xOTAuOCAxOTAuOC0xOTAuOGMxMDUuMiAwIDE5MC44IDg1LjYgMTkwLjggMTkwLjggMCAzOC4yLTExLjQgNzUuMi0zMyAxMDdsLTAuNCAwLjYgMC41IDUuMyA3OC41IDc4LjVjNiA2IDkuMyAxNCA5LjMgMjIuNXMtMy40IDE2LjUtOS40IDIyLjVjLTUuOSA2LTEzLjkgOS4zLTIyLjQgOS4zek03MDMuNCA1ODdjLTcwLjEgMC0xMjcuMiA1Ny4xLTEyNy4yIDEyNy4yczU3LjEgMTI3LjIgMTI3LjIgMTI3LjIgMTI3LjItNTcuMSAxMjcuMi0xMjcuMlM3NzMuNiA1ODcgNzAzLjQgNTg3eiIgIC8+PC9zdmc+Cg=="

/***/ }),

/***/ "3cEZ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("SJrK");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("24cb22ca", content, true, {});

/***/ }),

/***/ "624t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("/eZ2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21abc344_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("E5P/");
function injectStyle (ssrContext) {
  __webpack_require__("NKbH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21abc344"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21abc344_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "63HY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{border: _vm.hasBorder}},[(_vm.backBtn)?_c('img',{staticClass:"img-left",attrs:{"src":__webpack_require__("9B/N"),"alt":""},on:{"click":_vm.goDetail}}):_vm._e(),_vm._v(" "),(_vm.homeBtn)?_c('img',{staticClass:"img-left",attrs:{"src":__webpack_require__("9B/N"),"alt":""},on:{"click":_vm.goHome}}):_vm._e(),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.shareBtn)?_c('img',{staticClass:"img-right",attrs:{"src":__webpack_require__("azyM"),"alt":""},on:{"click":_vm.share}}):_vm._e(),_vm._v(" "),(_vm.serviceBtn)?_c('a',{staticClass:"img-right"},[_c('img',{attrs:{"src":__webpack_require__("ARau"),"alt":""},on:{"click":_vm.service}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7QMd":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiMzMzMzMzMiIGQ9Ik01MDAuOCA0NjEuOTA5MzMzTDI2Ny4zMDY2NjcgNjk1LjI5NmwtNDUuMjI2NjY3LTQ1LjI2OTMzMyAyNzguNzQxMzMzLTI3OC42MTMzMzRMNzc5LjMwNjY2NyA2NTAuMDI2NjY3bC00NS4yNDggNDUuMjI2NjY2eiIgLz48L3N2Zz4K"

/***/ }),

/***/ "7eQW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_config__ = __webpack_require__("BK/k");
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    backBtn: {
      type: Boolean,
      default: false
    },
    homeBtn: {
      type: Boolean,
      default: false
    },
    shareBtn: {
      type: Boolean,
      default: false
    },
    serviceBtn: {
      type: Boolean,
      default: false
    },
    hasBorder: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      msgUrl: __WEBPACK_IMPORTED_MODULE_0__util_config__["a" /* default */].msgUrl
    };
  },

  methods: {
    /**
     * 分享
     */
    share: function share() {
      this.$emit('share');
    },

    /**
     * 客服
     */
    service: function service() {
      if (cConf.serviceLineMe) {
        window.open('https://line.me/ti/p/UnTgQVExys#~');
      } else {
        window.open(this.msgUrl);
      }
      this.$emit('service');
    },

    /**
     * 返回详情页面
     */
    goDetail: function goDetail() {
      this.$router.push({
        path: '/detail',
        query: {
          id: this.$route.query.id,
          path: this.$route.query.path
        }
      });
    },

    /**
     * 返回首页
     */
    goHome: function goHome() {
      var defaultHome = '/static/home.html';
      var host = location.host;
      // const reg = /.*?([a-z0-9--]{1,200}.com)$/
      // const homeConfig = {
      //   "qualitygogo.com": "//my.qualitygogo.com/promotion/spring-sale-my",
      //   "golifestoretw.com": "//th.golifestoretw.com/promotion/spring-thai",
      //   "17ihome.com": "//thai.17ihome.com/promotion/sale-thai-21",
      //   "soanclothes.com": "//thai.soanclothes.com/promotion/clothes-sale-th",
      //   "americanwsh.com": "//th.americanwsh.com/promotion/sale-th2021",
      //   "warmthcorner.com": "//thai.warmthcorner.com/promotion/festival-sale21",
      //   "bluebirderr.com": "//tw.bluebirderr.com/promotion/blue-spring-sale",
      //   "stylels.com": "//tw.stylels.com/promotion/twsale2021",
      //   "darkgogo.com": "//tw.darkgogo.com/promotion/mensale-2021",
      //   "twgolifestore.com": "//good.twgolifestore.com/promotion/twspringsale",
      //   "stylishhoing.com": "//jp.stylishhoing.com/promotion/jp-spring-sale2021",
      //   "wshnetwork.com": "//sg.wshnetwork.com/promotion/sgonsale-2104",
      //   "pomeloinn.com": "//hk.pomeloinn.com/promotion/hongkongsale2021",
      //   "allbuythailand.com": "//thailand.allbuythailand.com/collections-big-sale"
      // }
      //
      // const regRes = host.match(reg)
      // if (regRes) {
      //   const rootHost = regRes[1];
      //   if (rootHost in homeConfig) {
      //     defaultHome = homeConfig[rootHost]
      //   }
      // }
      //
      // location.href = this.$route.query.home ? `${this.$route.query.home}?path=${this.$route.query.path || ''}` : defaultHome

      if (host !== 'localhost') {
        location.href = "https://" + host;
      } else {
        location.href = 'http://localhost/';
      }
    }
  }
});

/***/ }),

/***/ "8l8B":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".brief .sales[data-v-459ed1f3]{width:100%;padding:10px;margin:0 auto;color:#333;border-bottom:1px solid #eee}.brief .sales .price[data-v-459ed1f3]{font-size:1.5rem;color:#e31a07;font-weight:bolder}.brief .sales .price ins[data-v-459ed1f3]{font-size:1.625rem}.brief .sales .price del[data-v-459ed1f3]{color:#969090e0;font-size:1.25rem}.brief h1[data-v-459ed1f3]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;padding:5px;color:#333;font-size:1rem;line-height:26px;font-weight:700;border-bottom:1px solid #eee}.feature[data-v-459ed1f3]{padding:4px 8px;border-bottom:1px solid #eee;color:#e31a07;font-size:.875rem;font-weight:700}.feature span[data-v-459ed1f3]{margin-right:12px;white-space:nowrap}.service[data-v-459ed1f3]{padding:8px;border-bottom:1px solid #eee}.service span[data-v-459ed1f3]{font-size:.875rem;margin-right:10px}.service img[data-v-459ed1f3]{width:14px}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/components/detail/brief.vue"],"names":[],"mappings":"AACA,+BACE,WAAY,AACZ,aAAc,AACd,cAAe,AACf,WAAY,AACZ,4BAA8B,CAC/B,AACD,sCACE,iBAAkB,AAClB,cAAe,AACf,kBAAoB,CACrB,AACD,0CACE,kBAAoB,CACrB,AACD,0CACE,gBAAiB,AACjB,iBAAmB,CACpB,AACD,2BAEE,gBAAiB,AACjB,uBAAwB,AACxB,oBAAqB,AACrB,qBAAsB,AACtB,4BAA6B,AAC7B,YAAa,AACb,WAAY,AACZ,eAAgB,AAChB,iBAAkB,AAClB,gBAAkB,AAClB,4BAA8B,CAC/B,AACD,0BACE,gBAAiB,AACjB,6BAA8B,AAC9B,cAAe,AACf,kBAAmB,AACnB,eAAkB,CACnB,AACD,+BACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,0BACE,YAAa,AACb,4BAA8B,CAC/B,AACD,+BACE,kBAAoB,AACpB,iBAAmB,CACpB,AACD,8BACE,UAAY,CACb","file":"brief.vue","sourcesContent":["\n.brief .sales[data-v-459ed1f3] {\n  width: 100%;\n  padding: 10px;\n  margin: 0 auto;\n  color: #333;\n  border-bottom: 1px solid #eee;\n}\n.brief .sales .price[data-v-459ed1f3] {\n  font-size: 1.5rem;\n  color: #e31a07;\n  font-weight: bolder;\n}\n.brief .sales .price ins[data-v-459ed1f3] {\n  font-size: 1.625rem;\n}\n.brief .sales .price del[data-v-459ed1f3] {\n  color: #969090e0;\n  font-size: 1.25rem;\n}\n.brief h1[data-v-459ed1f3] {\n  /*text-overflow: -o-ellipsis-lastline;*/\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  padding: 5px;\n  color: #333;\n  font-size: 1rem;\n  line-height: 26px;\n  font-weight: bold;\n  border-bottom: 1px solid #eee;\n}\n.feature[data-v-459ed1f3] {\n  padding: 4px 8px;\n  border-bottom: 1px solid #eee;\n  color: #e31a07;\n  font-size: .875rem;\n  font-weight: bold;\n}\n.feature span[data-v-459ed1f3] {\n  margin-right: 12px;\n  white-space: nowrap;\n}\n.service[data-v-459ed1f3] {\n  padding: 8px;\n  border-bottom: 1px solid #eee;\n}\n.service span[data-v-459ed1f3] {\n  font-size: 0.875rem;\n  margin-right: 10px;\n}\n.service img[data-v-459ed1f3] {\n  width: 14px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "9B/N":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiMzMzMzMzMiIGQ9Ik02NDEuMjggMjc4LjYxMzMzM2wtNDUuMjI2NjY3LTQ1LjIyNjY2Ni0yNzguNjM0NjY2IDI3OC43NjI2NjYgMjc4LjYxMzMzMyAyNzguNDg1MzM0IDQ1LjI0OC00NS4yNjkzMzQtMjMzLjM2NTMzMy0yMzMuMjM3MzMzeiIgLz48L3N2Zz4K"

/***/ }),

/***/ "ARau":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Br8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_config__ = __webpack_require__("BK/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_permission__ = __webpack_require__("vZz+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    productData: {
      type: Object,
      default: {
        is_rich: '',
        content: [],
        content_iv: []
      }
    }
  },
  data: function data() {
    return {
      mp4Reg: /.+\.mp4/,
      loading: __WEBPACK_IMPORTED_MODULE_0__util_config__["a" /* default */].loading
    };
  },

  methods: {
    loaded: function loaded(e, index) {
      // 如果不是初始图，说明用户已经访问到该图片
      if (e.target.src !== __WEBPACK_IMPORTED_MODULE_0__util_config__["a" /* default */].loading) {
        this.$emit('imgLoad', { index: index + 1, timeStamp: e.timeStamp });
      }
    }
  },
  mounted: function mounted() {
    try {
      setTimeout(function () {
        var videoIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (item) {
            if (item.intersectionRatio === 0) {
              item.target.pause();
            } else {
              item.target.play();
            }
          });
        });
        var videoList = document.getElementById('product-info').getElementsByTagName('video');
        for (var i = 0; i < videoList.length; i++) {
          // 富文本视频添加属性 视频元素先操作一次保证自动播放
          videoList[i].muted = 'muted';
          videoList[i].loop = 'loop';
          videoList[i].controls = '';
          videoList[i].setAttribute('playsinline', 'playsinline');
          videoList[i].setAttribute('webkit-playsinline', 'webkit-playsinline');
          videoIo.observe(videoList[i]);
        }
      }, 100);
    } catch (e) {
      // 保证富文本视频按要求显示
      setTimeout(function () {
        var videoList = document.getElementById('product-info').getElementsByTagName('video');
        for (var i = 0; i < videoList.length; i++) {
          // 富文本视频添加属性 视频元素先操作一次保证自动播放
          videoList[i].muted = 'muted';
          videoList[i].loop = 'loop';
          videoList[i].controls = 'controls';
          videoList[i].setAttribute('playsinline', 'playsinline');
          videoList[i].setAttribute('webkit-playsinline', 'webkit-playsinline');
        }
      }, 100);
    }
  }
});

/***/ }),

/***/ "E5P/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{style:({'flex-direction': _vm.cConf.alignRight ? 'row-reverse' : ''})},[(_vm.config.btn_search_order)?_c('div',{staticClass:"icon-only",on:{"click":function($event){return _vm.search()}}},[_c('img',{attrs:{"src":__webpack_require__("2U1J"),"alt":""}})]):_vm._e(),_vm._v(" "),(!_vm.isGoogleSource && _vm.config.btn_contact)?_c('div',{staticClass:"icon-only",on:{"click":function($event){return _vm.service()}}},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"buy-now",style:({'width': (100 - (_vm.config.btn_search_order + (!_vm.isGoogleSource && _vm.config.btn_contact)) * 15) + '%'}),on:{"click":function($event){return _vm.pay()}}},[_c('img',{attrs:{"src":__webpack_require__("/SIw"),"alt":""}}),_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('img',{attrs:{"src":__webpack_require__("gUmo"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EQgq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    swiperData: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      // 轮播图高度
      swiperHeight: 0,
      // 最高的图片
      maxHeightImg: {},
      // 视频路径正则
      mp4Reg: /.+\.mp4/,
      // 轮播时间间隔
      timeGap: 4000
    };
  },
  created: function created() {
    var _this = this;

    // 有视频时停止轮播
    this.swiperData.map(function (item) {
      if (_this.mp4Reg.test(item)) {
        _this.timeGap = 0;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    // 初始长宽比1：1
    document.getElementsByClassName('mint-swipe')[0].style.height = window.innerWidth >= 640 ? 640 + 'px' : window.innerWidth + 'px';
    // 第一个是视频时自动播放，并自适应高度
    if (this.mp4Reg.test(this.swiperData[0])) {
      var timer = setInterval(function () {
        if (_this2.heightFlex(0) !== 'err') {
          _this2.$refs.img0[0].muted = 'muted';
          _this2.$refs.img0[0].play();
          clearInterval(timer);
        }
      }, 500);
    }
    // 视口变化高度变化
    window.onresize = function () {
      if (_this2.maxHeightImg[0] && _this2.maxHeightImg[0].naturalHeight && _this2.maxHeightImg[0].naturalWidth) {
        _this2.swiperHeight = _this2.maxHeightImg[0].naturalHeight / _this2.maxHeightImg[0].naturalWidth * (window.innerWidth >= 640 ? 640 : window.innerWidth);
        document.getElementsByClassName('mint-swipe')[0].style.height = _this2.swiperHeight + 'px';
      }
    };
  },

  methods: {
    /**
     * 轮播图变为视频时自动播放，其他视频暂停，并进行轮播高度适应
     * @param index 轮播索引
     */
    imgChange: function imgChange(index) {
      if (this.$refs['img' + index][0].tagName === 'VIDEO') {
        var videoList = document.getElementById('swiper').getElementsByTagName('video');
        for (var i = 0; i < videoList.length; i++) {
          videoList[i].pause();
        }
        this.$refs['img' + index][0].play();
        if (this.$refs['img' + index][0].videoHeight && this.$refs['img' + index][0].videoWidth) {
          this.$refs['img' + index][0].naturalHeight = this.$refs['img' + index][0].videoHeight;
          this.$refs['img' + index][0].naturalWidth = this.$refs['img' + index][0].videoWidth;
        }
        this.heightFlex(index);
      }
    },

    /**
     * 轮播高度适应
     * @param index 轮播索引
     * @returns {string} 'err'：无长宽数据
     */
    heightFlex: function heightFlex(index) {
      var formatHeight = this.$refs['img' + index][0].naturalHeight / this.$refs['img' + index][0].naturalWidth * (window.innerWidth >= 640 ? 640 : window.innerWidth);
      if (isNaN(formatHeight)) {
        return 'err';
      }
      if (formatHeight > this.swiperHeight || !this.maxHeightImg[0]) {
        this.swiperHeight = formatHeight;
        document.getElementsByClassName('mint-swipe')[0].style.height = this.swiperHeight + 'px';
        this.maxHeightImg = this.$refs['img' + index];
      }
      var classVal = this.$refs['img' + index][0].parentElement.getAttribute('class').concat(' flex-item');
      this.$refs['img' + index][0].parentElement.setAttribute('class', classVal);
    }
  }
});

/***/ }),

/***/ "EyIy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ok.a387f41.svg";

/***/ }),

/***/ "IZZV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("UyXE");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("53e38fe2", content, true, {});

/***/ }),

/***/ "JT2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    detailData: {
      type: Object,
      default: {}
    },
    lang: {
      type: Object,
      default: {}
    },
    config: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      cl: sessionStorage.cl,
      price: this.detailData.price && Number(this.detailData.price).toFixed(0),
      comparePrice: this.detailData.compare_price && Number(this.detailData.compare_price).toFixed(0),
      // 符号在价格后面的国家，对应detailData.iso_code
      symbolBehindPriceCode: ['ALL', // 阿尔巴尼亚
      'BGN', // 保加利亚
      'CZK', // 捷克
      'DKK', // 丹麦
      'HRK', // 克罗地亚
      'HUF', // 匈牙利
      'ISK', // 冰岛
      'MDL', // 摩尔多瓦
      'NOK', // 挪威
      'PLN', // 波兰
      'RON', // 罗马尼亚
      'RSD', // 塞尔维亚
      'SEK', // 瑞典
      'UAH' // 乌克兰
      ]
    };
  },

  computed: {
    filteredItems: function filteredItems() {
      var _this = this;

      var allowedProperties = ['free_shipping', 'cash_on_delivery', 'seven_day'];

      if (window.location.hostname === 'www.cheapct.top') {
        // 移除 'cash_on_delivery' 属性
        allowedProperties.splice(1, 1);
      }
      return allowedProperties.map(function (property) {
        return _this.lang[property];
      });
    },

    // 是否货币符合展示在价格后面
    isSymbolBehindPrice: function isSymbolBehindPrice() {
      return this.symbolBehindPriceCode.includes(this.detailData.iso_code);
    }
  }
});

/***/ }),

/***/ "KqOm":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".product-info{border-top:1px solid #eee;width:100%;overflow:hidden}.product-info img,.product-info video{width:100%!important;height:auto!important;vertical-align:bottom}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/components/detail/product-info.vue"],"names":[],"mappings":"AACA,cACI,0BAA2B,AAC3B,WAAY,AACZ,eAAiB,CACpB,AACD,sCAEI,qBAAuB,AACvB,sBAAwB,AACxB,qBAAuB,CAC1B","file":"product-info.vue","sourcesContent":["\n.product-info {\n    border-top: 1px solid #eee;\n    width: 100%;\n    overflow: hidden;\n}\n.product-info img,\n.product-info video {\n    width: 100% !important;\n    height: auto !important;\n    vertical-align: bottom;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "Mitt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("7eQW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5f885b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("63HY");
function injectStyle (ssrContext) {
  __webpack_require__("3cEZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c5f885b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5f885b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MzQH":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dLVE");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("64ff05fe", content, true, {});

/***/ }),

/***/ "NKbH":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("OjYw");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2cd10fa5", content, true, {});

/***/ }),

/***/ "OjYw":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "footer[data-v-21abc344]{position:fixed;bottom:-1px;left:0;right:0;margin:0 auto;width:100%;max-width:640px;height:50px;display:-webkit-box;display:-ms-flexbox;display:flex}footer>div[data-v-21abc344]{height:50px;border:1px solid #bbb;border-radius:4px;cursor:pointer}footer .icon-only[data-v-21abc344]{width:15%;padding:6px 0;background:#fff}footer .icon-only img[data-v-21abc344]{width:100%;height:100%}footer .buy-now[data-v-21abc344]{width:100%;text-align:center;line-height:50px;font-weight:700;background:#ed3323;color:#fff;font-size:1.25rem}footer .buy-now img[data-v-21abc344]{width:2rem;font-size:0;position:relative;top:-3px}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/components/detail/footer.vue"],"names":[],"mappings":"AACA,wBACE,eAAgB,AAChB,YAAa,AACb,OAAQ,AACR,QAAS,AACT,cAAe,AACf,WAAY,AACZ,gBAAiB,AACjB,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,4BACE,YAAa,AACb,sBAAuB,AACvB,kBAAmB,AACnB,cAAgB,CACjB,AACD,mCACE,UAAW,AACX,cAAe,AACf,eAAiB,CAClB,AACD,uCACE,WAAY,AACZ,WAAa,CACd,AACD,iCACE,WAAY,AACZ,kBAAmB,AACnB,iBAAkB,AAClB,gBAAkB,AAClB,mBAAoB,AACpB,WAAY,AACZ,iBAAmB,CACpB,AACD,qCACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,QAAU,CACX","file":"footer.vue","sourcesContent":["\nfooter[data-v-21abc344] {\n  position: fixed;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 640px;\n  height: 50px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\nfooter > div[data-v-21abc344] {\n  height: 50px;\n  border: 1px solid #bbb;\n  border-radius: 4px;\n  cursor: pointer;\n}\nfooter .icon-only[data-v-21abc344] {\n  width: 15%;\n  padding: 6px 0;\n  background: #fff;\n}\nfooter .icon-only img[data-v-21abc344]{\n  width: 100%;\n  height: 100%;\n}\nfooter .buy-now[data-v-21abc344] {\n  width: 100%;\n  text-align: center;\n  line-height: 50px;\n  font-weight: bold;\n  background: #ED3323;\n  color: #fff;\n  font-size: 1.25rem;\n}\nfooter .buy-now img[data-v-21abc344] {\n  width: 2rem;\n  font-size: 0;\n  position: relative;\n  top: -3px;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "QAmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brief_vue__ = __webpack_require__("JT2S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_459ed1f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brief_vue__ = __webpack_require__("zCGx");
function injectStyle (ssrContext) {
  __webpack_require__("zV5x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-459ed1f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brief_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_459ed1f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brief_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SJrK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "header[data-v-2c5f885b]{z-index:100;position:fixed;top:0;width:100%;max-width:640px;height:44px;background:#fff}.border[data-v-2c5f885b]{border-bottom:1px solid #eee}.img-left[data-v-2c5f885b]{float:left}.img-right[data-v-2c5f885b]{float:right;margin-left:0}header h1[data-v-2c5f885b]{z-index:-10;position:absolute;top:0;left:0;padding:0 44px;width:100%;height:44px;line-height:44px;text-align:center;font-size:16px;font-weight:700;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}header img[data-v-2c5f885b]{width:24px;margin:10px;cursor:pointer;background:#fff}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/components/common/header.vue"],"names":[],"mappings":"AACA,wBACE,YAAa,AACb,eAAgB,AAChB,MAAO,AACP,WAAY,AACZ,gBAAiB,AACjB,YAAa,AACb,eAA+B,CAChC,AACD,yBACE,4BAA8B,CAC/B,AACD,2BACE,UAAY,CACb,AACD,4BACE,YAAa,AACb,aAAe,CAChB,AACD,2BACE,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,gBAAkB,AAClB,gBAAiB,AACjB,mBAAoB,AACpB,sBAAwB,CACzB,AACD,4BACE,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,eAAiB,CAClB","file":"header.vue","sourcesContent":["\nheader[data-v-2c5f885b] {\n  z-index: 100;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  max-width: 640px;\n  height: 44px;\n  background: rgb(255, 255, 255);\n}\n.border[data-v-2c5f885b] {\n  border-bottom: 1px solid #eee;\n}\n.img-left[data-v-2c5f885b] {\n  float: left;\n}\n.img-right[data-v-2c5f885b] {\n  float: right;\n  margin-left: 0;\n}\nheader h1[data-v-2c5f885b] {\n  z-index: -10;\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: 0 44px;\n  width: 100%;\n  height: 44px;\n  line-height: 44px;\n  text-align: center;\n  font-size: 16px;\n  font-weight: bold;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\nheader img[data-v-2c5f885b] {\n  width: 24px;\n  margin: 10px;\n  cursor: pointer;\n  background: #fff;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "TAM/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper",attrs:{"id":"swiper"},on:{"touchstart":function($event){return _vm.$emit('touch')}}},[_c('mt-swipe',{attrs:{"auto":_vm.timeGap},on:{"change":function($event){return _vm.imgChange($event)}}},_vm._l((_vm.swiperData),function(item,index){return _c('mt-swipe-item',{key:item,class:_vm.mp4Reg.test(item) ? 'flex-item' : '',attrs:{"key":"1"}},[(!_vm.mp4Reg.test(item))?_c('img',{ref:'img'+index,refInFor:true,attrs:{"src":item,"alt":""},on:{"load":function($event){return _vm.heightFlex(index)}}}):_vm._e(),_vm._v(" "),(_vm.mp4Reg.test(item))?_c('video',{ref:'img'+index,refInFor:true,attrs:{"src":item,"muted":"muted","loop":"","controls":"","playsinline":"playsinline","webkit-playsinline":"webkit-playsinline","poster":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"},domProps:{"muted":true}}):_vm._e()])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U2uU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msginfo-box"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"head",attrs:{"id":"supply"},on:{"click":_vm.showDetail}},[_vm._v("\n      "+_vm._s(_vm.textData.title)+"\n      "),(_vm.detailControl)?_c('img',{attrs:{"src":__webpack_require__("7QMd"),"alt":""}}):_vm._e(),_vm._v(" "),(!_vm.detailControl)?_c('img',{attrs:{"src":__webpack_require__("orp/"),"alt":""}}):_vm._e()]),_vm._v(" "),(_vm.detailControl)?_c('ul',{attrs:{"id":"supply-detail"}},[_c('li',[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.textData.shipping_policy))]),_vm._v(" "),_c('dd',[_vm._v("\n            "+_vm._s(_vm.textData.shipping_policy_des)+"\n            "),_c('router-link',{staticClass:"dt-link",attrs:{"to":{path: '/shipping',
            query: {id: _vm.$route.query.id, path: _vm.$route.query.path}}}},[_vm._v(_vm._s(_vm.textData.detail))])],1)])]),_vm._v(" "),_c('li',[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.textData.faq))]),_vm._v(" "),_c('dd',[_vm._v("\n            "+_vm._s(_vm.textData.faq_des)+"\n            "),_c('router-link',{staticClass:"dt-link",attrs:{"to":{path: '/faq',
            query: {id: _vm.$route.query.id, path: _vm.$route.query.path}}}},[_vm._v(_vm._s(_vm.textData.detail))])],1)])]),_vm._v(" "),_c('li',[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.textData.refund_policy))]),_vm._v(" "),_c('dd',[_vm._v("\n            "+_vm._s(_vm.textData.refund_policy_des)+"\n            "),(_vm.cConf.jpSupply)?_c('span',[_c('a',{staticClass:"dt-link",attrs:{"href":'mailto:' + _vm.mail}},[_vm._v(_vm._s(_vm.mail))]),_vm._v("\n              にて弊社スタッフまで返品の着金状況をお問い合わせくださいませ。\n            ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"dt-link",attrs:{"to":{path: '/return',
            query: {id: _vm.$route.query.id, path: _vm.$route.query.path}}}},[_vm._v(_vm._s(_vm.textData.detail))])],1)])]),_vm._v(" "),_c('li',[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.textData.service_policy))]),_vm._v(" "),_c('dd',[_vm._v("\n            "+_vm._s(_vm.textData.service_policy_des)+"\n            "),_c('router-link',{staticClass:"dt-link",attrs:{"to":{path: '/privacy',
            query: {id: _vm.$route.query.id, path: _vm.$route.query.path}}}},[_vm._v(_vm._s(_vm.textData.detail))])],1)])]),_vm._v(" "),_c('li',[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.textData.contact_us))]),_vm._v(" "),_c('dd',[_vm._v("\n            "+_vm._s(_vm.textData.contact_us_des)+"\n            "),_c('br'),_vm._v(" "),(!_vm.cConf.jpSupply)?_c('div',[_c('div',{staticStyle:{"margin-top":"10px","word-wrap":"break-word"},style:({float: _vm.cConf.alignRight ? 'right' : 'left'})},[(_vm.isYahooSource)?_c('p',[_vm._v(_vm._s(_vm.textData.mall_name)+_vm._s(_vm.host))]):_vm._e(),_vm._v(" "),(_vm.isGoogleSource)?_c('p',[_vm._v("\n                  "+_vm._s(_vm.textData.address_k)+"\n                  "+_vm._s(_vm.textData.address_v)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.isGoogleSource)?_c('p',[_vm._v("\n                  "+_vm._s(_vm.textData.phone_k)+"\n                  "+_vm._s(_vm.textData.phone_v)+"\n                ")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.textData.email_k || 'Mail：')+"\n                  "),_c('a',{staticClass:"dt-link",attrs:{"href":'mailto:' + _vm.mail}},[_vm._v(_vm._s(_vm.mail))])])])]):_vm._e()])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UyXE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".swiper{width:100%;position:relative}.swiper .mint-swipe .mint-swipe-items-wrap{width:100%;height:100%}.swiper .mint-swipe .flex-item{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.swiper .mint-swipe img,.swiper .mint-swipe video{vertical-align:middle;width:100%;-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/components/detail/swiper.vue"],"names":[],"mappings":"AACA,QACI,WAAY,AACZ,iBAAmB,CACtB,AAID,2CACI,WAAY,AACZ,WAAa,CAChB,AACD,+BACI,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,mCAAqC,AACjC,gCAAkC,AAC9B,4BAA+B,CAC1C,AACD,kDAEI,sBAAuB,AACvB,WAAY,AACZ,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC","file":"swiper.vue","sourcesContent":["\n.swiper {\n    width: 100%;\n    position: relative;\n}\n.swiper .mint-swipe {\n    /*height: 100vw;*/\n}\n.swiper .mint-swipe .mint-swipe-items-wrap {\n    width: 100%;\n    height: 100%;\n}\n.swiper .mint-swipe .flex-item {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important; /*副轴居中*/\n}\n.swiper .mint-swipe img,\n.swiper .mint-swipe video {\n    vertical-align: middle;\n    width: 100%;\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; /*主轴居中*/\n}\n\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "VzaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YOb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("EQgq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7c0839_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("TAM/");
function injectStyle (ssrContext) {
  __webpack_require__("IZZV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7c0839_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YwTY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_module_title_vue__ = __webpack_require__("+hMR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2998814_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_module_title_vue__ = __webpack_require__("VzaH");
function injectStyle (ssrContext) {
  __webpack_require__("iRUE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a2998814"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_module_title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2998814_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_module_title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "azyM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiMzMzMzMzMiIGQ9Ik0zOTUuOTQ2NjY3IDIzNC42NjY2Njd2NjRIMjU2djQ2OS4zMzMzMzNoNTEyVjUyMi42NjY2NjdoNjRWNzY4YTY0IDY0IDAgMCAxLTY0IDY0SDI1NmE2NCA2NCAwIDAgMS02NC02NFYyOTguNjY2NjY3YTY0IDY0IDAgMCAxIDY0LTY0aDEzOS45NDY2Njd6IG0zMzUuODUwNjY2LTg3LjkxNDY2N2wxNTAuODQ4IDE1MC44MjY2NjctMTU4LjM3ODY2NiAxNTguNC00NS4yNjkzMzQtNDUuMjQ4TDc0OC4zOTQ2NjcgMzQxLjMzMzMzM0g2NzJjLTEyMS42ODUzMzMgMC0yMjAuNzE0NjY3IDk3LjAyNC0yMjMuOTE0NjY3IDIxNy45NDEzMzRMNDQ4IDU2NS4zMzMzMzN2ODUuMzMzMzM0aC02NHYtODUuMzMzMzM0QzM4NCA0MDYuMjcyIDUxMi45Mzg2NjcgMjc3LjMzMzMzMyA2NzIgMjc3LjMzMzMzM2g5OS44NjEzMzNsLTg1LjMxMi04NS4zMzMzMzMgNDUuMjQ4LTQ1LjI0OHoiIC8+PC9zdmc+Cg=="

/***/ }),

/***/ "dLVE":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".msginfo-box[data-v-59acbfac]{color:#555;font-size:12px}.msginfo-box .item[data-v-59acbfac]{font-size:12px;line-height:21px}.msginfo-box .item .head[data-v-59acbfac]{padding-left:37px;height:37px;text-align:center;font-weight:600;background:url(" + escape(__webpack_require__("hxqi")) + ") 50%;background-size:auto 100%;font-size:1rem;line-height:37px;cursor:pointer}.msginfo-box .item .head img[data-v-59acbfac]{padding:8px;float:right;display:block;width:37px;height:37px;right:12px;font-size:0}.msginfo-box .item dl[data-v-59acbfac]{margin:0}.msginfo-box .item dl dd[data-v-59acbfac],.msginfo-box .item dl dt[data-v-59acbfac]{display:table-cell;padding:10px;border:1px solid #eee;vertical-align:middle;word-break:break-word}.msginfo-box .item dl dt[data-v-59acbfac]{min-width:70px;width:15%;text-align:center;border-right:none;border-bottom:none}.msginfo-box .item dl dd[data-v-59acbfac]{width:640px;border-bottom:none}.msginfo-box .item dl dd img[data-v-59acbfac]{max-width:100%;border:0;vertical-align:middle;width:70px}.dt-link[data-v-59acbfac]{color:#f8770e;cursor:pointer;text-decoration:none}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/components/detail/supply.vue"],"names":[],"mappings":"AACA,8BACE,WAAY,AACZ,cAAgB,CACjB,AACD,oCACE,eAAgB,AAChB,gBAAkB,CACnB,AACD,0CACE,kBAAmB,AACnB,YAAa,AACb,kBAAmB,AACnB,gBAAiB,AACjB,6CAA6D,AAC7D,0BAA2B,AAC3B,eAAgB,AAChB,iBAAkB,AAClB,cAAgB,CACjB,AACD,8CACE,YAAa,AACb,YAAa,AACb,cAAe,AACf,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,WAAa,CACd,AACD,uCACE,QAAU,CACX,AACD,oFAEE,mBAAoB,AACpB,aAAc,AACd,sBAAuB,AACvB,sBAAuB,AACvB,qBAAuB,CACxB,AACD,0CACE,eAAgB,AAChB,UAAW,AACX,kBAAmB,AACnB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,0CACE,YAAa,AACb,kBAAoB,CACrB,AACD,8CACE,eAAgB,AAChB,SAAU,AACV,sBAAuB,AACvB,UAAY,CACb,AACD,0BACE,cAAe,AACf,eAAgB,AAChB,oBAAsB,CACvB","file":"supply.vue","sourcesContent":["\n.msginfo-box[data-v-59acbfac] {\n  color: #555;\n  font-size: 12px;\n}\n.msginfo-box .item[data-v-59acbfac] {\n  font-size: 12px;\n  line-height: 21px;\n}\n.msginfo-box .item .head[data-v-59acbfac] {\n  padding-left: 37px;\n  height: 37px;\n  text-align: center;\n  font-weight: 600;\n  background: url(../../assets/img/detail/title-bg.png) center;\n  background-size: auto 100%;\n  font-size: 1rem;\n  line-height: 37px;\n  cursor: pointer;\n}\n.msginfo-box .item .head img[data-v-59acbfac]{\n  padding: 8px;\n  float: right;\n  display: block;\n  width: 37px;\n  height: 37px;\n  right: 12px;\n  font-size: 0;\n}\n.msginfo-box .item dl[data-v-59acbfac] {\n  margin: 0;\n}\n.msginfo-box .item dl dt[data-v-59acbfac],\n.msginfo-box .item dl dd[data-v-59acbfac] {\n  display: table-cell;\n  padding: 10px;\n  border: 1px solid #eee;\n  vertical-align: middle;\n  word-break: break-word;\n}\n.msginfo-box .item dl dt[data-v-59acbfac] {\n  min-width: 70px;\n  width: 15%;\n  text-align: center;\n  border-right: none;\n  border-bottom: none;\n}\n.msginfo-box .item dl dd[data-v-59acbfac] {\n  width: 640px;\n  border-bottom: none;\n}\n.msginfo-box .item dl dd img[data-v-59acbfac] {\n  max-width: 100%;\n  border: 0;\n  vertical-align: middle;\n  width: 70px;\n}\n.dt-link[data-v-59acbfac] {\n  color: #F8770E;\n  cursor: pointer;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "f/s3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_permission__ = __webpack_require__("vZz+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mail: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isGoogleSource: source === sourceData.googleSource,
      detailControl: source === sourceData.googleSource,
      textData: {},
      cl: sessionStorage.cl,
      isYahooSource: localStorage.source === sourceData.yahooSource,
      host: location.host.replace(/^www\./, '').replace(/.com$/, ''),
      cConf: cConf
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_permission__["s" /* getSupply */])();

            case 2:
              res = _context.sent;

              _this.textData = res.data;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    showDetail: function showDetail() {
      this.detailControl = !this.detailControl;
      setTimeout(function () {
        window.scrollTo({
          top: window.scrollY + 1000,
          left: 0,
          behavior: 'smooth'
        });
      }, 100);
    }
  }
});

/***/ }),

/***/ "gUmo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "hT17":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".module-title[data-v-a2998814]{width:100%;background:url(" + escape(__webpack_require__("hxqi")) + ") 50%;background-size:auto 100%}.module-title h2[data-v-a2998814]{height:37px;text-align:center;font-size:1rem;line-height:37px}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/components/detail/module-title.vue"],"names":[],"mappings":"AACA,+BACE,WAAY,AACZ,6CAA6D,AAC7D,yBAA2B,CAC5B,AACD,kCACE,YAAa,AACb,kBAAmB,AACnB,eAAgB,AAChB,gBAAkB,CACnB","file":"module-title.vue","sourcesContent":["\n.module-title[data-v-a2998814] {\n  width: 100%;\n  background: url(../../assets/img/detail/title-bg.png) center;\n  background-size: auto 100%;\n}\n.module-title h2[data-v-a2998814]{\n  height: 37px;\n  text-align: center;\n  font-size: 1rem;\n  line-height: 37px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "hxqi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "iRUE":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("hT17");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("ed7102ee", content, true, {});

/***/ }),

/***/ "mw5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_info_vue__ = __webpack_require__("Br8f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57cdcdf7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_info_vue__ = __webpack_require__("pyXE");
function injectStyle (ssrContext) {
  __webpack_require__("pXs2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57cdcdf7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "orp/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiMzMzMzMzMiIGQ9Ik01MDAuOCA2MDQuNzc5TDI2Ny4zMDcgMzcxLjM5MmwtNDUuMjI3IDQ1LjI3IDI3OC43NDEgMjc4LjYxM0w3NzkuMzA3IDQxNi42NmwtNDUuMjQ4LTQ1LjI0OHoiIC8+PC9zdmc+Cg=="

/***/ }),

/***/ "pXs2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("KqOm");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7494d68a", content, true, {});

/***/ }),

/***/ "pyXE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-info",attrs:{"id":"product-info"}},[(!_vm.productData.is_rich)?_c('div',_vm._l((_vm.productData.content_iv),function(item,index){return _c('p',[(!_vm.mp4Reg.test(item))?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item),expression:"item"}],attrs:{"alt":"","src":""},on:{"load":function($event){return _vm.loaded($event, index)}}}):_vm._e(),_vm._v(" "),(_vm.mp4Reg.test(item))?_c('video',{attrs:{"src":item,"muted":"","loop":"","controls":"","playsinline":"playsinline","webkit-playsinline":"webkit-playsinline","poster":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"},domProps:{"muted":true}}):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.productData.is_rich)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.productData.content)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sZlY":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("vQBv");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("129c044a", content, true, {});

/***/ }),

/***/ "vQBv":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".detail[data-v-942e7d82]{margin:0 auto;max-width:640px;min-height:100%;background:#fff}.detail .container[data-v-942e7d82]{padding:0 0 50px}.margin-top[data-v-942e7d82]{margin-top:44px}.buy-now[data-v-942e7d82]{margin:14px 22px;padding:8px 0;border:1px solid #bbb;border-radius:5px;font-size:1rem;background:#e31a07}.buy-now[data-v-942e7d82],.totop[data-v-942e7d82]{color:#fff;text-align:center;text-decoration:none;cursor:pointer}.totop[data-v-942e7d82]{z-index:20;border-radius:45px;width:45px;line-height:45px;right:15px;position:fixed;bottom:60px;display:block;height:45px;border:1px solid #232323;background:#000;opacity:.4}", "", {"version":3,"sources":["/Users/zhouzhuang/software/IdeaProjects/cartx/web/shop/src/views/Detail.vue"],"names":[],"mappings":"AACA,yBACI,cAAe,AACf,gBAAiB,AACjB,gBAAiB,AACjB,eAAiB,CACpB,AACD,oCACI,gBAAkB,CACrB,AACD,6BACI,eAAiB,CACpB,AACD,0BACI,iBAAkB,AAClB,cAAe,AACf,sBAAuB,AACvB,kBAAmB,AAEnB,eAAgB,AAChB,kBAAoB,CAIvB,AACD,kDAPI,WAAY,AAGZ,kBAAmB,AACnB,qBAAsB,AACtB,cAAgB,CAmBnB,AAjBD,wBACI,WAAY,AAEZ,mBAAoB,AACpB,WAAY,AACZ,iBAAkB,AAClB,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,cAAe,AAEf,YAAa,AACb,yBAA0B,AAE1B,gBAAiB,AACjB,UAAa,CAEhB","file":"Detail.vue","sourcesContent":["\n.detail[data-v-942e7d82] {\n    margin: 0 auto;\n    max-width: 640px;\n    min-height: 100%;\n    background: #fff;\n}\n.detail .container[data-v-942e7d82] {\n    padding: 0 0 50px;\n}\n.margin-top[data-v-942e7d82] {\n    margin-top: 44px;\n}\n.buy-now[data-v-942e7d82] {\n    margin: 14px 22px;\n    padding: 8px 0;\n    border: 1px solid #bbb;\n    border-radius: 5px;\n    color: #fff;\n    font-size: 1rem;\n    background: #E31A07;\n    text-align: center;\n    text-decoration: none;\n    cursor: pointer;\n}\n.totop[data-v-942e7d82] {\n    z-index: 20;\n    text-decoration: none;\n    border-radius: 45px;\n    width: 45px;\n    line-height: 45px;\n    right: 15px;\n    position: fixed;\n    bottom: 60px;\n    display: block;\n    text-align: center;\n    height: 45px;\n    border: 1px solid #232323;\n    color: #fff;\n    background: #000;\n    opacity: 0.4;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "vlyD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_supply_vue__ = __webpack_require__("f/s3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59acbfac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_supply_vue__ = __webpack_require__("U2uU");
function injectStyle (ssrContext) {
  __webpack_require__("MzQH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59acbfac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_supply_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59acbfac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_supply_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zCGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brief"},[_c('div',{staticClass:"sales"},[_c('div',{staticClass:"price"},[(!_vm.isSymbolBehindPrice)?_c('span',{style:({'letter-spacing': _vm.detailData.symbol === '฿' ? '3px' : ''})},[_vm._v(_vm._s(_vm.detailData.symbol))]):_vm._e(),_vm._v(" "),_c('ins',[_vm._v(_vm._s(_vm.price))]),_vm._v(" "),(_vm.isSymbolBehindPrice)?_c('span',[_vm._v(_vm._s(_vm.detailData.symbol))]):_vm._e(),_vm._v(" "),(_vm.detailData.iso_code === 'JPY')?_c('span',{staticStyle:{"font-size":"18px","color":"#333"}},[_vm._v("(税抜)")]):_vm._e(),_vm._v(" "),(!_vm.isSymbolBehindPrice)?_c('del',{style:({'letter-spacing': _vm.detailData.symbol === '฿' ? '2px' : ''})},[_vm._v(_vm._s(_vm.detailData.symbol))]):_vm._e(),_vm._v(" "),_c('del',[_vm._v(_vm._s(_vm.comparePrice))]),_vm._v(" "),(_vm.isSymbolBehindPrice)?_c('del',[_vm._v(_vm._s(_vm.detailData.symbol))]):_vm._e()])]),_vm._v(" "),_c('h1',{domProps:{"innerHTML":_vm._s(_vm.detailData.title)}}),_vm._v(" "),(_vm.config.show_feature)?_c('div',{staticClass:"feature"},_vm._l((['續航強', '性價比高', '外形時尚']),function(item){return _c('span',{key:item},[_vm._v(_vm._s(item))])}),0):_vm._e(),_vm._v(" "),(_vm.config.show_service)?_c('div',{staticClass:"service"},_vm._l((_vm.filteredItems),function(item){return _c('span',{key:item},[_c('img',{attrs:{"src":__webpack_require__("EyIy"),"alt":""}}),_vm._v("\n        "+_vm._s(item)+"\n      ")])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zV5x":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8l8B");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0db00b5c", content, true, {});

/***/ }),

/***/ "zmit":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[(_vm.$route.query.home || _vm.configData.page_detail.top.show || _vm.isGoogleSource || _vm.isPromotion)?_c('zf-header',{attrs:{"title":_vm.detailData.title,"shareBtn":_vm.configData.page_detail.top.show_share,"homeBtn":true},on:{"share":_vm.share}}):_vm._e(),_vm._v(" "),(_vm.loaded === 'success')?_c('div',{staticClass:"container",class:{'margin-top': _vm.configData.page_detail.top.show}},[_c('zf-swiper',{attrs:{"swiperData":_vm.detailData.images},on:{"touch":_vm.swiperTouch}}),_vm._v(" "),_c('zf-brief',{attrs:{"detailData":_vm.detailData,"lang":_vm.lang,"config":_vm.configData.page_detail.detail}}),_vm._v(" "),(_vm.configData.page_detail.detail.show_buy_button)?_c('div',{staticClass:"buy-now",on:{"click":function($event){return _vm.goPay('home_middle')}}},[_vm._v("\n            "+_vm._s(_vm.lang.buy_now)+"\n        ")]):_vm._e(),_vm._v(" "),_c('zf-title',{attrs:{"title":_vm.lang.product_detail}}),_vm._v(" "),_c('zf-info',{attrs:{"productData":_vm.detailData.content},on:{"imgLoad":_vm.imgLoad}}),_vm._v(" "),_c('zf-supply',{attrs:{"mail":_vm.configData.email}})],1):_vm._e(),_vm._v(" "),(_vm.loaded === 'error')?_c('div',{staticStyle:{"text-align":"center","padding-top":"40vh","padding-bottom":"calc(60vh - 100px)"},on:{"click":_vm.getDetail}},[_c('img',{staticStyle:{"width":"50px"},attrs:{"src":__webpack_require__("/YhV"),"alt":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        product no found\n    ")]):_vm._e(),_vm._v(" "),_c('zf-footer',{attrs:{"config":_vm.configData.page_detail.foot,"text":_vm.lang.buy_now},on:{"pay":function($event){return _vm.goPay('home_bottom')},"search":_vm.search,"service":_vm.service}}),_vm._v(" "),_c('span',{staticClass:"totop",on:{"click":_vm.toTop}},[_vm._v("TOP")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.fd7cdfed4efafdf02f8c.js